import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validator, NgForm, Validators } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { formatDate } from "@angular/common";

import { CustomerService } from "./shared/customer.service";
import { CommonmastersService } from "../commonmasters/commonmasters.service";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})

export class CustomerComponent implements OnInit {

  AddButtonText: string = "Save";
  btnvisibility: boolean = true;
  ErrorText: string;
  ParentCustomerNo: number;
  ParentSurveyNo: number = 0;
  defaultFont: any;
  customerForm: FormGroup;
  isSubmitted: boolean = false;
  panelOpenState: boolean = false;
  imgPhotoURL: any = null;
  imgIdProofURL: any = null;
  imgAddressProofURL: any = null;
  PhotoName: any = null;
  IdProofName: any = null;
  AddressProofName: any = null;

  selectedPhotoFile: File = null;
  selectedIdProofFile: File = null;
  selectedAddressProofFile: File = null;
  formData: FormData;

  constructor(public customerService: CustomerService,
    public commonmastersService: CommonmastersService,
    private router: Router, private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder, public datePipe: DatePipe,
    private sanitizer: DomSanitizer) {

    this.formData = new FormData();
  }

  IdProofsList: any[] = [];
  RelationList: any[] = [];
  LoanPurposeList: any[] = [];
  MartialStatusList: any[] = [];
  BranchList: any[] = [];
  CategoryList: any[] = [];
  OccupationList: any[] = [];
  OccupationStatusList: any[] = [];
  CountryList: any[] = [];
  StateList: any[] = [];
  DistrictsList: any[] = [];
  AgentList: any[] = [];
  IsSurveyCustomer: boolean = false;
  AutoGeneratedCustomerNo: number;

  ngOnInit() {

    this.activatedRoute.params.subscribe(param => {
      this.ParentCustomerNo = + param['Id'];  //Customer No
    });

    this.activatedRoute.params.subscribe(param => {
      this.ParentSurveyNo = + param['Id1'];  //Survey No
    });

    this.GetBranchList();
    this.GetCategoryList();
    this.GetIdProofList();
    this.GetOccupationsList();
    this.GetOccupationStatusList();
    this.GetRelationList();
    this.GetMartialStatusList();
    this.GetCountryList();
    this.GetStateList();
    this.GetDistrictsList();
    this.GetAgentList();
    this.GetLoanPurpose(); // for survey
    this.resetForm();
    this.getAutogeneratedNumber();

    this.customerService.selectedCustomer.GenderId = 2; 

    if (Number.isNaN(this.ParentCustomerNo)) {
      this.customerService.selectedCustomer.Id = 0;
      this.customerService.selectedCustomer.Flag = 1;
      this.customerService.selectedCustomer.IsActive = true;

      const dateNow = this.getMMDDYYYY(new Date);
      // this.customerService.selectedCustomer.DOB = this.datePipe.transform(new Date(), 'yyyy-MM-dd'); 
      this.customerService.selectedCustomer.DOB = dateNow;

      // console.log(this.customerService.selectedCustomer.DOB);
      this.AddButtonText = "Save";
    }
    else {
      this.customerService.selectedCustomer.Id = +this.ParentCustomerNo;
      this.customerService.selectedCustomer.Flag = 2;
      this.AddButtonText = "Edit & Save";
      this.getCustomersByCustomerNo();
    }

    // to enable survey customer attribute
    if (!Number.isNaN(this.ParentSurveyNo)) {
      this.IsSurveyCustomer = true;
    }

    if (!Number.isNaN(this.ParentSurveyNo) && !Number.isNaN(this.ParentCustomerNo)) {
      this.IsSurveyCustomer = true;
    }
  }


  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.customerService.selectedCustomer = {

      Id: null,
      CustomerNo: this.getCustomerNumber(),
      SurveyNo: 0,
      CustomerBranchId: 0,
      Title: 2,
      FirstName: null,
      LastName: null,
      AliasName: null,
      GenderId: 2,
      DOB: null,
      CategoryId: 0,
      Area: null,
      OccupationId: 0,
      Mobile: null,
      Email: null,
      Father: null,
      Guardian: null,
      GuardianRelationId: 0,
      MartialStatus: 0,
      Nominee: null,
      NomineeRelationId: 0,
      AadharNo: null,
      PANNo: null,
      Tax: null,
      BankAcNo: null,
      BankName: null,
      BankBranchName: null,
      IFSC: null,
      AgentId: 0,
      ExistingLoan: null,
      IdProof: 0,
      IdProofNo: null,
      IdProofIssued: null,
      IdProofValidity: null,
      AddressProofId: 0,
      AddressProofNo: null,
      AddressProofIssued: null,
      AddressProofValidity: null,
      AddressMobile: null,
      AddressPhone: null,
      Address: null,
      Place: null,
      PostOffice: null,
      Pincode: null,
      Village: null,
      Panchayath: null,
      Taluk: null,
      District: 0,
      State: 1,
      CountryId: 1,
      PermanentAddress: null,
      PermanentPlace: null,
      PermanentPostOffice: null,
      PermanentPincode: null,
      PermanentVillage: null,
      PermanentPanchayath: null,
      PermanentTaluk: null,
      PermanentDistrict: 0,
      PermanentState: 1,
      PermanentCountryId: 1,
      OfficeAddress: null,
      OfficePlace: null,
      OfficePostOffice: null,
      OfficePincode: null,
      OfficeVillage: null,
      OfficePanchayath: null,
      OfficeTaluk: null,
      OfficeDistrict: 0,
      OfficeState: 1,
      OfficeCountryId: 1,
      NomineeAddress: null,
      NomineePlace: null,
      NomineePostOffice: null,
      NomineePincode: null,
      NomineeVillage: null,
      NomineePanchayath: null,
      NomineeTaluk: null,
      NomineeDistrict: 0,
      NomineeState: 1,
      NomineeCountryId: 1,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: true,
      Flag: 1,

      AnnualIncome: null,
      SurveyAmount: null,
      LoanPurposeId: 0,
      SurveyStatusId: true,

      IsCustomerSearch: false,
      IsPresentAddessSame: false,
      IsOfficeAddessSame: false,
      IsNomineeAddessSame: false,

      // for report
      ReportName: null,
      BranchId: 0,
      CentreId: 0,
      LoanTypeId: 0,
      LoanCategoryId: 0,
      SchemeId: 0,

      PhotoFileName: null,
      IdProofFileName: null,
      AddressProofName: null,
      PhotoFilePath: null,
      IdProofFilePath: null,
      AddressProofFilePath: null,
    }
  }

  getAutogeneratedNumber(): any {
    if (Number.isNaN(this.ParentCustomerNo)) { // Parent customer number checks
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.customerService.selectedCustomer.CustomerNo = res[0].AutoGeneratedId;
          this.AutoGeneratedCustomerNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.AutoGeneratedCustomerNo = this.ParentCustomerNo;
    }
  }

  getCustomerNumber(): number {
    if (this.ParentCustomerNo == undefined) {
      return this.AutoGeneratedCustomerNo;
    }
    else {
      return this.AutoGeneratedCustomerNo = this.ParentCustomerNo;
    }
  }

  getCustomersByCustomerNo() {
    if (!Number.isNaN(this.ParentCustomerNo)) {
      this.customerService.selectedCustomer.Id = this.ParentCustomerNo;
      this.customerService.FetchCustomerByCustomerId(this.customerService.selectedCustomer).subscribe(data => {
     
        this.customerService.selectedCustomer = data;
        // formatting the Date while editing
        const formattedDate =  this.getMMDDYYYY(data.DOB) ;

        this.customerService.selectedCustomer.DOB = formattedDate;
        this.customerService.selectedCustomer.Flag = 2;

        this.imgPhotoURL = data.PhotoFilePath;
        this.imgIdProofURL = data.IdProofFilePath ;
        this.imgAddressProofURL =data.AddressProofFilePath;

        // let objectURL = 'data:image/jpeg;base64,' + data.PhotoFilePath.image;

        this.imgPhotoURL =  this.sanitizer.bypassSecurityTrustUrl(data.PhotoFilePath);

        // this.imgPhotoURL = this.getBase64Image(data.PhotoFilePath);
      })
    }
  }

  getMMDDYYYY(date) {
    var today = new Date(date);
    console.log(date);

    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();

    // if (dd < 10)
    //     dd = 0 + dd
    // if (mm < 10)
    //     mm = 0 + mm
    // return mm + '/' + dd + '/' + yyyy;

      const formattedDate =  (mm <10 ? '0' + mm : mm) + '/' + (dd <10 ? '0'+ dd : dd) + '/' + yyyy;
      return this.datePipe.transform(formattedDate, 'yyyy-MM-dd'); 
  }

  getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.classList.add('myStyle');
    console.log(img.width, 'x', img.height);
    canvas.width = 446;
    canvas.height = 631;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
    return { img: dataURL, width: canvas.width, height: canvas.height };
  }

  public onSubmit(form: NgForm) {

    this.btnvisibility = false; // for restrict multiple press

    form.value.GenderId = this.customerService.selectedCustomer.GenderId;
    form.value.SurveyNo = this.ParentSurveyNo;

    if (form.value.CustomerBranchId != 0) {

      this.customerService.IUDCustomer(form.value)
        .toPromise()
        .then(data => {
          // this.resetForm(form);
          if (!Number.isNaN(this.ParentSurveyNo)) {

            if (!Number.isNaN(this.ParentCustomerNo)) {
              this.router.navigate(['/surveyentry', { Id: 701, Id1: this.ParentSurveyNo }]); //edit
            }
            else {
              this.router.navigate(['/surveyentry', { Id: 501, Id1: this.ParentSurveyNo }]);
            }
          }
          else {
            // // Uploading the files based on the customerId after save 
            var newCustomerId = data.UniqueId;
            this.uploadFiles(form.value.CustomerNo);
            this.router.navigate(['/customerlist']);
          }
        })
    }
    else {
      this.ErrorText = "Invalid Customer Branch"
    }
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GetCategoryList() {
    this.commonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
    })
  }

  GetOccupationsList() {
    this.commonmastersService.GetOccupationsList().subscribe(data => {
      this.OccupationList = data;
    })
  }

  GetOccupationStatusList() {
    this.commonmastersService.GetOccupationStatusList().subscribe(data => {
      this.OccupationStatusList = data;
    })
  }

  GetRelationList() {
    this.commonmastersService.GetRelationList().subscribe(data => {
      this.RelationList = data;
    })
  }

  GetMartialStatusList() {
    this.commonmastersService.GetMartialStatusList().subscribe(data => {
      this.MartialStatusList = data;
    })
  }

  GetIdProofList() {
    this.commonmastersService.GetIdProofList().subscribe(data => {
      this.IdProofsList = data;
    })
  }

  GetCountryList() {
    this.commonmastersService.GetCountryList().subscribe(data => {
      this.CountryList = data;
    })
  }

  GetStateList() {
    this.commonmastersService.GetStateList().subscribe(data => {
      this.StateList = data;
    })
  }

  GetDistrictsList() {
    this.commonmastersService.GetDistrictsList().subscribe(data => {
      this.DistrictsList = data;
    })
  }

  GetAgentList() {
    this.commonmastersService.GetAgentList().subscribe(data => {
      this.AgentList = data;
    })
  }

  GetLoanPurpose() {  // for survey
    this.commonmastersService.FetchLoanPurpose().subscribe(data => {
      this.LoanPurposeList = data;
    })
  }

  GetIsPresentAddess(checked) {
    if (!this.customerService.selectedCustomer.IsPresentAddessSame) {
      this.customerService.selectedCustomer.PermanentAddress = this.customerService.selectedCustomer.Address;
      this.customerService.selectedCustomer.PermanentPlace = this.customerService.selectedCustomer.Place;
      this.customerService.selectedCustomer.PermanentPostOffice = this.customerService.selectedCustomer.PostOffice;
      this.customerService.selectedCustomer.PermanentPincode = this.customerService.selectedCustomer.Pincode;
      this.customerService.selectedCustomer.PermanentVillage = this.customerService.selectedCustomer.Village
      this.customerService.selectedCustomer.PermanentPanchayath = this.customerService.selectedCustomer.Panchayath
      this.customerService.selectedCustomer.PermanentTaluk = this.customerService.selectedCustomer.Taluk
      this.customerService.selectedCustomer.PermanentDistrict = this.customerService.selectedCustomer.District;
      this.customerService.selectedCustomer.PermanentState = this.customerService.selectedCustomer.State;
      this.customerService.selectedCustomer.PermanentCountryId = this.customerService.selectedCustomer.CountryId;
    }
    else {
      this.customerService.selectedCustomer.PermanentAddress = null;
      this.customerService.selectedCustomer.PermanentPlace = null;
      this.customerService.selectedCustomer.PermanentPostOffice = null;
      this.customerService.selectedCustomer.PermanentPincode = null;
      this.customerService.selectedCustomer.PermanentVillage = null;
      this.customerService.selectedCustomer.PermanentPanchayath = null;
      this.customerService.selectedCustomer.PermanentTaluk = null;
      this.customerService.selectedCustomer.PermanentDistrict = null;
      this.customerService.selectedCustomer.PermanentState = null;
      this.customerService.selectedCustomer.PermanentCountryId = null;
    }

  }

  GetIsOfficeAddess(checked) {
    if (!this.customerService.selectedCustomer.IsOfficeAddessSame) {
      this.customerService.selectedCustomer.OfficeAddress = this.customerService.selectedCustomer.Address;
      this.customerService.selectedCustomer.OfficePlace = this.customerService.selectedCustomer.Place;
      this.customerService.selectedCustomer.OfficePostOffice = this.customerService.selectedCustomer.PostOffice;
      this.customerService.selectedCustomer.OfficePincode = this.customerService.selectedCustomer.Pincode;
      this.customerService.selectedCustomer.OfficeVillage = this.customerService.selectedCustomer.Village
      this.customerService.selectedCustomer.OfficePanchayath = this.customerService.selectedCustomer.Panchayath
      this.customerService.selectedCustomer.OfficeTaluk = this.customerService.selectedCustomer.Taluk
      this.customerService.selectedCustomer.OfficeDistrict = this.customerService.selectedCustomer.District;
      this.customerService.selectedCustomer.OfficeState = this.customerService.selectedCustomer.State;
      this.customerService.selectedCustomer.OfficeCountryId = this.customerService.selectedCustomer.CountryId;
    }
    else {
      this.customerService.selectedCustomer.OfficeAddress = null;
      this.customerService.selectedCustomer.OfficePlace = null;
      this.customerService.selectedCustomer.OfficePostOffice = null;
      this.customerService.selectedCustomer.OfficePincode = null;
      this.customerService.selectedCustomer.OfficeVillage = null;
      this.customerService.selectedCustomer.OfficePanchayath = null;
      this.customerService.selectedCustomer.OfficeTaluk = null;
      this.customerService.selectedCustomer.OfficeDistrict = null;
      this.customerService.selectedCustomer.OfficeState = null;
      this.customerService.selectedCustomer.OfficeCountryId = null;
    }
  }

  GetIsNomineeAddess(checked) {
    if (!this.customerService.selectedCustomer.IsNomineeAddessSame) {
      this.customerService.selectedCustomer.NomineeAddress = this.customerService.selectedCustomer.Address;
      this.customerService.selectedCustomer.NomineePlace = this.customerService.selectedCustomer.Place;
      this.customerService.selectedCustomer.NomineePostOffice = this.customerService.selectedCustomer.PostOffice;
      this.customerService.selectedCustomer.NomineePincode = this.customerService.selectedCustomer.Pincode;
      this.customerService.selectedCustomer.NomineeVillage = this.customerService.selectedCustomer.Village
      this.customerService.selectedCustomer.NomineePanchayath = this.customerService.selectedCustomer.Panchayath
      this.customerService.selectedCustomer.NomineeTaluk = this.customerService.selectedCustomer.Taluk
      this.customerService.selectedCustomer.NomineeDistrict = this.customerService.selectedCustomer.District;
      this.customerService.selectedCustomer.NomineeState = this.customerService.selectedCustomer.State;
      this.customerService.selectedCustomer.NomineeCountryId = this.customerService.selectedCustomer.CountryId;

    }
    else {
      this.customerService.selectedCustomer.NomineeAddress = null;
      this.customerService.selectedCustomer.NomineePlace = null;
      this.customerService.selectedCustomer.NomineePostOffice = null;
      this.customerService.selectedCustomer.NomineePincode = null;
      this.customerService.selectedCustomer.NomineeVillage = null;
      this.customerService.selectedCustomer.NomineePanchayath = null;
      this.customerService.selectedCustomer.NomineeTaluk = null;
      this.customerService.selectedCustomer.NomineeDistrict = null;
      this.customerService.selectedCustomer.NomineeState = null;
      this.customerService.selectedCustomer.NomineeCountryId = null;
    }
  }

  uploadPhoto(event) {
    // Get the file selected.
 
    const selectedFile = event.target.files[0];
    this.selectedPhotoFile = event.target.files[0];
    this.PhotoName = selectedFile.name;

    // changing the file name and appending the file type to it ie, selectedFile.type
    let CustomerNo : string = this.customerService.selectedCustomer.CustomerNo.toString();
    let ImageType = event.target.files[0].type.split("/"); // getting file extension 
    this.formData.append('PhotoFile', event.target.files[0], CustomerNo + "." + ImageType[1]);
  
    // To display the selected image before deciding to upload it.
    let reader = new FileReader();

    // Gets a 'base64' representation of an image.
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (event2) => {
      // Sets the html <img> tag to the image.
      this.imgPhotoURL = reader.result;
    };
  
  }

  uploadIdProof(event) {
    // Get the file selected.
    const selectedFile = event.target.files[0];
    this.selectedIdProofFile = event.target.files[0];
    this.IdProofName = selectedFile.name;

    // To display the selected image before deciding to upload it.
    let reader = new FileReader();

    // Gets a 'base64' representation of an image.
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (event2) => {
      // Sets the html <img> tag to the image.
      this.imgIdProofURL = reader.result;
    };

    // changing the file name and appending the file type to it ie, selectedFile.type
    let CustomerNo : string = this.customerService.selectedCustomer.CustomerNo.toString();
    let ImageType = event.target.files[0].type.split("/");
    this.formData.append('IdProofFile', event.target.files[0], CustomerNo +'.'+ ImageType[1]);
  }

  uploadAddressProof(event) {
    // Get the file selected.
    const selectedFile = event.target.files[0];
    this.selectedAddressProofFile = event.target.files[0];
    this.AddressProofName = selectedFile.name;
    
    // To display the selected image before deciding to upload it.
    let reader = new FileReader();

    // Gets a 'base64' representation of an image.
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (event2) => {
      // Sets the html <img> tag to the image.
      this.imgAddressProofURL = reader.result;
    };

    // changing the file name and appending the file type to it ie, selectedFile.type
    let CustomerNo : string = this.customerService.selectedCustomer.CustomerNo.toString();
    let ImageType = event.target.files[0].type.split("/");
    this.formData.append('AddressProofFile', event.target.files[0], CustomerNo +'.'+ ImageType[1]);
  }

  // private uploadFile(file: File): Observable<HttpEvent<unknown>> {
  //   const url = 'http://localhost:8080/upload';
  //   const formData: FormData = new FormData();
  //   formData.append('file', file, file.name);

  //   return this.httpClient.post(
  //     url,
  //     formData,
  //     {
  //       reportProgress: true,
  //       observe: 'events'
  //     }
  //   );
  // }

  // Uploading the files based on the customerId after save 
  uploadFiles(CustomerId : any) {
   
    this.customerService.IUDCustomerFiles(this.formData)
      .subscribe(data => {
        // this.resetForm(form);
      });
  }

}
